import { AutogenModelQualifierCode, AutogenRowQualifierCode } from "./autogen/AutogenModelQualifierCode";

export class ModelQualifierCode extends AutogenModelQualifierCode<RowQualifierCode> {
	constructor() {
		super(RowQualifierCode);
	}
}

export class RowQualifierCode extends AutogenRowQualifierCode {
}